(() => {
  const initialize = (root) => {
    if (root.dataset.cpsInitialized === 'true') return;
    root.dataset.cpsInitialized = 'true';

    const type = root.querySelector('[data-cps-design-type]');
    const stockFields = root.querySelector('[data-cps-stock-fields]');
    const customFields = root.querySelector('[data-cps-custom-fields]');
    const stockDesign = root.querySelector('[data-cps-stock-design]');
    const customInputs = Array.from(root.querySelectorAll('[data-cps-custom-input]'));
    const reference = root.querySelector('[data-cps-reference]');
    const status = root.querySelector('[data-cps-status]');
    const formId = type.getAttribute('form');
    const form = document.getElementById(formId);

    const toggle = () => {
      const service = root.dataset.cpsService === 'true';
      const custom = type.value === 'Custom artwork';
      stockFields.hidden = custom || service;
      stockDesign.disabled = custom || service;
      stockDesign.required = !custom && !service;
      customFields.hidden = !custom;
      customInputs.forEach((input) => {
        input.disabled = !custom;
        if (input.type === 'file' || input.type === 'email' || input.type === 'checkbox') input.required = custom && !service;
      });
    };

    type.addEventListener('change', toggle);
    toggle();

    if (!form) return;
    form.addEventListener('submit', async (event) => {
      if (type.value !== 'Custom artwork') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      status.textContent = '';
      if (!form.reportValidity()) return;
      if (reference.files[0] && reference.files[0].size > 20971520) {
        status.textContent = 'The uploaded file must be 20 MB or smaller.';
        return;
      }

      const button = form.querySelector('[type="submit"]');
      if (button) button.disabled = true;

      try {
        const customResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!customResponse.ok) throw new Error('We could not add this item. Please try again.');

        window.location.href = '/cart';
      } catch (error) {
        status.textContent = error.message;
        if (button) button.disabled = false;
      }
    }, true);
  };

  const initializeAll = () => {
    document.querySelectorAll('[data-cps-order-options]').forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();